module.exports = __webpack_public_path__ + "static/media/amm.617e8608.jpg";